// import { LOCAL } from "@/store/mutations";

// const { ALLOCATE_BUDGET, RESET_BUDGET } = LOCAL;

export default {
	namespaced: true,
	state: () => ({
		id: null,
		content: "",
		next_button_text: "",
		overlay_coverage: "",
		selector: "",
	}),
	actions: {
	},
	mutations: {
	},
};



// WEBPACK FOOTER //
// ./src/store/tutorial/steps/single.store.js